import React, { useState, useEffect, useRef } from 'react';
import ConversationTableCompleted from '../../../features/supervision/conversations/components/ConversationTable/Completed/ConversationTableCompleted';
import ConversationTableInProgress from '../../../features/supervision/conversations/components/ConversationTable/InProgress/ConversationTableInProgress';
import ConversationTableUpGoing from '../../../features/supervision/conversations/components/ConversationTable/UpGoing/ConversationTableUpGoing';
import { PageTable, Header } from '/src/layouts/page';
import { setStorageParamForCurrentCompany, getStorageParamForCurrentCompany } from '/src/utils/storageParamForCurrentCompany';
import { env } from '/src/var/env';
import SliderTab from '/src/components/slider/sliderTab';
import IconButton from '/src/components/UI/Button/IconButton/IconButton';
import { TabNameProvider } from '../../../hooks/tabNameContext';
import storage from "/src/utils/storage";
import ModalManager from "@ebay/nice-modal-react";
import ApiModal from "/src/components/modal/ApiModal/ApiModal";
import ConversationUpGoingService from '../../../features/supervision/conversations/services/ConversationUpGoingService';
import hasPermission from '/src/utils/hasPermission';
import { useToastDispatchContext } from '/src/layouts/toast/context/toastContext';

function ConversationList() {
    const company = storage('session').get('company');
    const { is_admin } = storage('local').get('user');
    const { deleteAllConversation } = ConversationUpGoingService;
    const [ refreshTableForce, setRefreshTableForce] = useState(false);
    const refreshList = () => {
        setItems([...items.map(item=>item)])
    }
    const getItems = ()=>{
        return [
            { name: 'Completed', component: <ConversationTableCompleted setRefreshList={refreshList}/>, type: 0 },
            { name: 'In progress', component: <ConversationTableInProgress setRefreshList={refreshList} />, type: 1 },
            { name: 'Upgoing', component: <ConversationTableUpGoing  setRefreshList={refreshList} resetList={refreshTableForce}/>, type: 2 }
        ]
    }

    const token = storage('local').get('token');
    const toast = useToastDispatchContext();
    const [selectedIndex, setSelectedIndex] = useState(0);
    const [downloadUrl, setDownloadUrl] = useState('');
    const [showMcpPopover, setShowMcpPopover] = useState(false);
    const mcpRef = useRef();

    const mcpUrl = `${env.REACT_APP_API_PATH.split("/api/v1")[0]}/mcp/conversations/api?key=${token}&company=${company.id}`;

    useEffect(() => {
        if (!showMcpPopover) return;
        const handleClick = (e) => {
            if (mcpRef.current && !mcpRef.current.contains(e.target)) {
                setShowMcpPopover(false);
            }
        };
        document.addEventListener('mousedown', handleClick);
        return () => document.removeEventListener('mousedown', handleClick);
    }, [showMcpPopover]);

    const [items, setItems] = useState(getItems());

    useEffect(() => {
        const selectedTab = items[selectedIndex];
        const currentFilters = getStorageParamForCurrentCompany('conversation_filters');
        const url = new URL(`${env.REACT_APP_API_PATH}/export/conversations/xlsx`);
        url.searchParams.append('token_auth', token);
        url.searchParams.append('type', selectedTab.type);

        Object.keys(currentFilters).forEach(key => {
            if (currentFilters[key]) {
                if (Array.isArray(currentFilters[key])) {
                    url.searchParams.append(key, currentFilters[key].join(','));
                } else {
                    url.searchParams.append(key, currentFilters[key]);
                }
            }
        });

        url.searchParams.append('company', company.id);
        const decodedUrl = url.toString().replace(/%2C/g, ',');
        setDownloadUrl(decodedUrl);
    }, [selectedIndex, token, company]);

    const handleTabChange = (index) => {
        setSelectedIndex(index);
    };

    const deleteAction = async () => {

        ModalManager.show(ApiModal, {
            title : 'Delete all upgoing conversations from  ' + company.name,
            body: 'Do you really want to delete all upgoing conversations from the company ' + company.name + " ?",
            api : {
                request : deleteAllConversation,
                param : [company.id]
            },
            buttons : [
                {className : 'validate', label : 'Cancel'},
                {className : 'cancel', label : 'Delete', type : 'submit'},
            ],
            confirm : {
                name: company.name,
                fieldName: "your company",
            }
        }).then( ()=> {refreshForce()})
    }
    const refreshForce = () => {
        setItems(getItems().map((item, index) => {
            if (item.type === 2) {
              return {
                ...item,
                component: <ConversationTableUpGoing  setRefreshList={refreshList} resetList={!refreshTableForce}/>
              };
            }
            return item; 
          }));
        setRefreshTableForce(!refreshTableForce)
    }

    return (
        <TabNameProvider>
            <PageTable>
                <Header title={<span> List of Last Conversations from <span style={{ color: "var(--main)" }}>{company.name}</span></span>}>
                    <div style={{ position: 'relative', display: 'inline-flex' }} ref={mcpRef}>
                        <IconButton
                            className="icons_up main-iconButton profil_action main_add-button space_tableButton"
                            icon="fas fa-link"
                            title="MCP API"
                            onClick={() => setShowMcpPopover(o => !o)}
                        />
                        {showMcpPopover && (
                            <div style={{
                                position: 'absolute',
                                top: 'calc(100% + 8px)',
                                right: 0,
                                zIndex: 1000,
                                background: 'white',
                                borderRadius: '16px',
                                padding: '28px',
                                boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
                                minWidth: '460px',
                            }}>
                                <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '12px' }}>
                                    <div className="button-leave" onClick={() => setShowMcpPopover(false)}>
                                        <i className="fa fa-times" aria-hidden="true"></i>
                                    </div>
                                </div>
                                <p style={{ margin: '0 0 20px 0', fontWeight: 700, fontSize: '22px', color: 'var(--text)', textAlign: 'center' }}>MCP API</p>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                    <input
                                        readOnly
                                        value={mcpUrl}
                                        className="input full-width"
                                        style={{ pointerEvents: 'none', userSelect: 'none', cursor: 'default', flex: 1, width: 'auto' }}
                                    />
                                    <i
                                        className="fas fa-copy"
                                        style={{ cursor: 'pointer', color: 'var(--main)', fontSize: '18px', flexShrink: 0 }}
                                        title="Copy MCP URL"
                                        onClick={() => navigator.clipboard.writeText(mcpUrl).then(() => {
                                            toast.success('Copied!', 'MCP API URL copied to clipboard', 3000);
                                            setShowMcpPopover(false);
                                        })}
                                    />
                                </div>
                            </div>
                        )}
                    </div>
                    <a href={downloadUrl} rel="noopener noreferrer">
                        <IconButton className="icons_up main-iconButton profil_action main_add-button space_tableButton" icon="fas fa-download" title="Export Conversations"></IconButton>
                    </a>
                    { (selectedIndex == 0) &&
                        <a href={downloadUrl+"&message=false"} rel="noopener noreferrer">
                            <IconButton className="icons_up main-iconButton profil_action main_add-button space_tableButton" icon="fas fa-file-archive" title="Export Conversations without message"></IconButton>
                        </a>
                    }
                

                    { ((is_admin || hasPermission('delete_conversation')) && selectedIndex == 2) ? <IconButton onClick={deleteAction} className=" icons_up main-iconButton delete_action main_add-button space_tableButton red-button-action-bg_color" icon="fas fa-trash" title="Delete All Conversations Upgoing"/> : null} 
                </Header>
               <SliderTab items={items} name="conversations" type="table" onTabChange={handleTabChange} />
            </PageTable>
        </TabNameProvider>
    );
}

export default ConversationList;
